export default "__VITE_ASSET__Ci9NcI67__"